module.exports = __webpack_public_path__ + "img/no-chat.4ee2eef0.svg";